function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import LogosAdvancedFieldsConfig from "segments/desktop/core-components/logos/advanced-fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({
        alignToLogo: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        segmentHeight: {
            type: FIELD_TYPES.TEXT,
            label: "Segment Height"
        },
        segmentMinHeight: {
            type: FIELD_TYPES.TEXT,
            label: "Segment Min Height"
        },
        segmentMaxHeight: {
            type: FIELD_TYPES.TEXT,
            label: "Segment Max Height"
        },
        videoPlayerWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Video Player Width"
        },
        videoPlayerMinWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Video Player Min Width"
        },
        videoPlayerHeight: {
            type: FIELD_TYPES.TEXT,
            label: "Video Player Height"
        },
        videoPlayerPositionTop: {
            type: FIELD_TYPES.TEXT,
            label: "Video Player Position Top"
        },
        videoPlayerPositionLeft: {
            type: FIELD_TYPES.TEXT,
            label: "Video Player Position Left"
        },
        logosBottomMargin: {
            type: FIELD_TYPES.TEXT,
            label: "Logos Bottom Margin"
        }
    }, SharedAdvancedFieldsConfig), {
        paragraphAdvancedProps: {
            type: FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Props",
            fields: _object_spread_props(_object_spread({}, FullParagraphAdvancedFieldsConfig), {
                marginTop: {
                    type: FIELD_TYPES.TEXT,
                    label: "Margin Top"
                },
                marginBottom: {
                    type: FIELD_TYPES.TEXT,
                    label: "Margin Bottom"
                }
            })
        },
        topLogosAdvancedProps: {
            type: FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: {
                textAndLogosMargin: {
                    type: FIELD_TYPES.TEXT,
                    label: "Space between text and logo"
                },
                logosAdvancedProps: {
                    type: FIELD_TYPES.NESTED,
                    label: "Logos Advanced Props",
                    fields: LogosAdvancedFieldsConfig
                }
            }
        }
    })
};
